import { render, staticRenderFns } from "./SubscriptionExtendDialog.vue?vue&type=template&id=12c56ca8&scoped=true"
import script from "./SubscriptionExtendDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionExtendDialog.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionExtendDialog.vue?vue&type=style&index=0&id=12c56ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c56ca8",
  null
  
)

export default component.exports